import React from "react";
import ReactApexChart from "react-apexcharts";

export default function DoubleChart({ label, title, yTitle, name1, name2, series1, series2, minYaxis, forecastedValue = 0 }) {

  let options = {
    chart: {
      type: 'line',
      stacked: false,
    },
    stroke: {
      width: [0, 4]
    },
    title: {
      text: title
    },
    plotOptions: {
      bar: {
        columnWidth: '50%'
      }
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [1],
      formatter: function (val) {
        if(val !== null) {
          return val.toFixed(2) + " %";
        }
      }
    },
    labels: label,
    markers: {
      size: 1
    },
    yaxis: [{
      title: {
        text: yTitle + ' in 1,000,000$',
      },
      min: minYaxis,
      labels: {
        formatter: function (val) {
          return (val / 1000000).toFixed(2);
        },
      }
    }, {
      opposite: true,
      title: {
        text: 'YoY Change in %'
      },
      labels: {
        formatter: function (val) {
          return (val).toFixed(2);
        },
      }
    }],
    tooltip: {
      shared: true,
      intersect: false,
      y: [{
        formatter: function (y) {
          if(typeof y !== "undefined") {
            if(y === forecastedValue ) return y.toFixed(2) + " $  (Estimate)";
            else return  y.toFixed(2) + " $";
          }
          return y;
        }
      }, {
        formatter: function (y) {
          if(y !== null) {
            return  y.toFixed(2) + " %";
          }
          return y;
        }
      }]
    },
    colors: [function({ value, seriesIndex }) {
      if(seriesIndex === 0) {
        if(value === forecastedValue ) return '#D9534F';
        else return '#239df9';
      }
      else return '#26e7a6';
    }]
  };
  
  let series = [{
    name: name1,
    type: 'column',
    data: series1
  }, {
    name: name2,
    type: 'line',
    data: series2
  }];

  return (
    <ReactApexChart options={options} series={series} type="line" width={800} />
  );
  
}